import React from "react";
import styles from "./Property.module.scss";
import { PropertyCard } from "../Listings/PropertyCard/PropertyCard";
import { useNavigate, useLocation } from "react-router-dom";
import { Header } from "../Header/Header";
import { SubHeader } from "../Overview/SubHeader/SubHeader";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { BasicInfoCard } from "./BasicInfoCard/BasicInfoCard";
import SingleBedIcon from "@mui/icons-material/SingleBed";
import BathtubIcon from "@mui/icons-material/Bathtub";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Footer } from "../Overview/Footer/Footer";
import GoogleMapsLogo from "../assets/google-maps-logo.png";
import {
  useGetDocumentByDocumentId,
  useGetDocumentsByQuery,
} from "../Hooks/FetchHook";

export const Property: React.FC = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  const propertyId = queryParams.get("propertyId");

  const { data: propertyInfo, isLoading: isLoadingPropertyInfo } =
    useGetDocumentByDocumentId("propiedad", propertyId as string);

  const { data: similarListings, isLoading: isLoadingSimilarListings } =
    useGetDocumentsByQuery("propiedad", [], 3);

  const clickRedirectFn = (propertyId: string) => {
    const params = new URLSearchParams({
      propertyId,
    }).toString();
    navigate(`/property?${params}`);
  };

  const openGoogleMaps = (latitude: string, longitude: string) => {
    const coordinates = `${latitude},${longitude}`;
    const googleMapsURL = `https://www.google.com/maps?q=${coordinates}`;
    window.open(googleMapsURL, "_blank");
  };

  const calculateDaysPassed = () => {
    if (propertyInfo.createdAt) {
      const createdAtDate = propertyInfo.createdAt.toDate();
      const currentDate = new Date(); // Current date and time
      const timeDifference = currentDate.getTime() - createdAtDate.getTime(); // Difference in milliseconds
      const daysPassed = timeDifference / (1000 * 3600 * 24); // Convert milliseconds to days
      return Math.floor(daysPassed); // Return the number of full days that have passed
    }
    return 1;
  };

  if (isLoadingPropertyInfo || isLoadingSimilarListings) {
    return <div>Loading...</div>;
  } else
    return (
      <div className={styles.propertyContainer}>
        <Header overviewStyle={false} />
        <SubHeader overviewStyle={false} />
        <div className={styles.contentContainer}>
          {/* <button className={styles.backBtn}>⬅ Back to map</button> */}
          <div className={styles.images}>
            <ImageGallery
              items={propertyInfo.imagenesURLs.map((image: any) => ({
                original: image,
                thumbnail: image,
              }))}
              thumbnailPosition="right"
              showPlayButton={false}
            />
          </div>
          <div className={styles.details}>
            <div className={styles.basicInfo}>
              <BasicInfoCard
                title={"Cuartos"}
                Icon={SingleBedIcon}
                value={propertyInfo.habitaciones}
              />
              <BasicInfoCard
                title={"baños"}
                Icon={BathtubIcon}
                value={propertyInfo.banos}
              />
              <BasicInfoCard
                title={"Terreno"}
                Icon={CheckBoxOutlineBlankIcon}
                value={propertyInfo.terreno + " m²"}
              />
              <BasicInfoCard
                title={"Estatus"}
                Icon={CheckCircleOutlineIcon}
                value={"Dispobible"}
              />
            </div>
            <div className={styles.priceContainer}>
              <p className={styles.priceTitle}>Precio de {(propertyInfo.tipoDeNegocio).toLowerCase()}</p>
              <p className={styles.price}>
                {Number(propertyInfo.precio).toLocaleString("en")}
              </p>
              <button>Me interesa</button>
            </div>
          </div>
          <div className={styles.details}>
            <div className={styles.separationDetails}>
              <h2>Acerca de esta casa</h2>
              {propertyInfo.descripcion
                .split("*")
                .map((paragraph: string, idx: number) => (
                  <p key={idx}>{paragraph}</p>
                ))}
            </div>
            <div></div>
          </div>
          <div className={styles.details}>
            <div className={styles.separationDetails}>
              <h2>Propiedades</h2>
              <div className={styles.rentalFeatures}>
                <p>
                  Publicado <span>hace {calculateDaysPassed()} dias</span>
                </p>
                <p>
                  <span>Disponible</span>
                </p>
                <p>
                  Tipo de propiedad <span>{propertyInfo.tipoDePropiedad}</span>
                </p>
                <p>
                  Ciudad <span>{propertyInfo.ciudad}</span>
                </p>
                <p>
                  Año de construccion{" "}
                  <span>{propertyInfo.anoDeConstruccion}</span>
                </p>
                <p>
                  Construccion <span>{propertyInfo.construccion} m²</span>
                </p>
                <p>
                  Terreno <span>{propertyInfo.terreno} m²</span>
                </p>
                <p>
                  Estacionamiento{" "}
                  <span>{propertyInfo.estacionamiento} cajones</span>
                </p>
              </div>
            </div>
            <div></div>
          </div>
          <div className={styles.details}>
            <div className={styles.separationDetails}>
              <h2>Ubicacion</h2>
              <img
                onClick={() =>
                  openGoogleMaps(propertyInfo.latitud, propertyInfo.longitud)
                }
                src={GoogleMapsLogo}
                className={styles.googleMapsLogo}
                alt="Google maps logo"
              />
            </div>
            <div></div>
          </div>

          <div className={styles.similarListingsContainer}>
            <h2>Propiedades similares</h2>
            <div className={styles.similarListings}>
              {similarListings &&
                similarListings.map((listing) => (
                  <PropertyCard
                    key={listing.id}
                    property={listing}
                    clickFn={clickRedirectFn}
                  />
                ))}
            </div>
          </div>
          <Footer />
        </div>
      </div>
    );
};
